// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const FileIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.7221 1.61108V9.66664H25.7777M20.9444 16.1111H9.66658M20.9444 20.9444H9.66658M12.8888 11.2778H9.66658M17.9235 1.61108H7.45131C6.0054 1.61108 4.83325 2.76519 4.83325 4.18886V24.8111C4.83325 26.2348 6.0054 27.3889 7.45131 27.3889H23.1596C24.6056 27.3889 25.7777 26.2348 25.7777 24.8111V9.34442L17.9235 1.61108Z"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FileIcon;
